import React from 'react';
import { styled } from '@linaria/react';

function New(props: React.HTMLAttributes<HTMLElement>) {
  return <Wrapper {...props}>New</Wrapper>;
}

const Wrapper = styled.sup`
  display: inline-block;
  font-size: 0.6em;
  transform: translateY(-0.3em);
  color: hsl(276deg 70% 75%);
  text-transform: uppercase;
  font-weight: var(--font-weight-bold);
`;

export default New;
